import {useMemo} from "react";
import {BoolCol, NumberCol, StringCol, Table, ViewOnly} from "../../../../misc/scroller/Table";
import {hasPermission, useUser} from "../../../../misc/Permission";
import {PurchaseOrderItem, SourceMode, ToSourceItem} from "../../../../api/Logistics";
import {ProjectCol, toSourceTableName} from "../PartsToSource";
import {CheckboxSelectorCol} from "../../../project/shopdrawing/Checkbox";
import {api} from "../../../../api/API";
import {DistributionMode} from "../DistributionModeToggle";
import {useActionCol} from "./ActionCol";
import {getAll} from "../../routes/useGetAll";
import {DateFilterCol} from "../../../../misc/DateFilterForCol";

// Glass panels to source. The opening column stays (unlike Div 10, a glazing row is tied to the
// opening it was drawn for), and the glazing properties come off the product's glass spec.
export function Glazing(props: {
    purchaseOrder?: number;
    supplier?: {
        id: number;
        name: string;
    };
    sourceMode: SourceMode;
    distributionMode: DistributionMode;
}) {
    const usr = useUser();

    const mfg = props.supplier?.id || 0;
    const key = useMemo(() => props.purchaseOrder + "-" + mfg, [props.purchaseOrder, mfg]);

    const supplier: any = [];
    if(!props.supplier) {
        supplier.push(ViewOnly(StringCol<ToSourceItem>("Supplier", "supplierName", 200)));
    }

    const isRestock = props.sourceMode === "stock";

    const actionCol = useActionCol({
        purchaseOrder: props.purchaseOrder,
        sourceMode: props.sourceMode,
        update: (input: Partial<PurchaseOrderItem>, dt: ToSourceItem) => {
            return Object.assign({}, input, {
                kind: dt.kind,
            })
        }
    });

    return (
        <Table<ToSourceItem>
            key={key}
            name={toSourceTableName}
            overridePrefsName={toSourceTableName + ".glazing." + props.sourceMode}
            columns={[
                props.purchaseOrder ? CheckboxSelectorCol({
                    disabled: (row: ToSourceItem) => !hasPermission(usr, "CanReleaseAndPurchase") && usr?.id === row.releasedBy,
                }) : null,
                !isRestock && ViewOnly(ProjectCol("Project", "projectName", 100)),
                DateFilterCol<ToSourceItem>("Due", "neededBy", "MMM D, YYYY", 100, "future"),
                ...supplier,
                ViewOnly(NumberCol("Need", "qty", 60)),
                isRestock && ViewOnly(NumberCol("Stock", "stockQty", 60)),
                isRestock && ViewOnly(NumberCol("Rsrvd", "reservedQty", 60)),
                isRestock && ViewOnly(NumberCol("Pend.PO", "purchasedQty", 90)),
                ViewOnly(StringCol("Opening", "openingName", 100)),
                ViewOnly(StringCol("Type", "glassType", 100)),
                ViewOnly(StringCol("Thickness", "glassThickness", 90)),
                ViewOnly(BoolCol("Thermal", "glassThermal", 80)),
                ViewOnly(StringCol("Bead", "glassBead", 100)),
                ViewOnly(StringCol("Width", "glassWidth", 90)),
                ViewOnly(StringCol("Height", "glassHeight", 90)),
                ViewOnly(StringCol("Note", "glazingNote", 150)),
                actionCol,
            ]}
            fetch={ctx => getAll(ctx, offset => api.logistics.listToSourceItems({
                offset,
                supplier: props.supplier?.id,
                type: "glazing",
                sourceMode: props.sourceMode,
                distributionMode: props.distributionMode,
            }))}
            fetchDeps={[props.supplier, props.sourceMode, props.distributionMode]}
        />
    )
}
